package link.erpango.quip.data.db.entities

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.async.coroutines.awaitAsOne
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import link.erpango.quip.db.QuipDb
import link.erpango.quip.db.SparePartDocument
import link.erpango.quip.domain.entities.DSparePartDocument

class SparePartDocumentDAO(
    val db: QuipDb
): ISparePartDocumentTable {

    override suspend fun insert(document: DSparePartDocument): Long {
        db.sparePartDocumentQueries.insertDocument(
            id = document.localId, // Use localId if available, otherwise SQLite will autoincrement
            server_id = if (document.id != 0L) document.id else null,
            spare_part_id = document.localSparePartId ?: 0, // This is local PK
            server_spare_part_id = document.sparePartId, // This is server ID
            vehicle_vin = document.vehicleVin,
            name = document.name,
            file_path = document.filePath,
            file_type = document.fileType,
            created_at = document.createdAt,
            size_mb = document.sizeMb,
            updated_at = document.updatedAt
        )
        return lastInsertRowId()
    }

    override suspend fun lastInsertRowId(): Long {
        return db.sparePartDocumentQueries.last_insert_rowid().awaitAsOne()
    }

    override suspend fun selectAll(): List<DSparePartDocument> {
        return db.sparePartDocumentQueries.selectAll().awaitAsList().map { it.toDSparePartDocument() }
    }

    override suspend fun selectBySparePartId(sparePartId: Long): List<DSparePartDocument> {
        return db.sparePartDocumentQueries.selectBySparePartId(sparePartId).awaitAsList().map { it.toDSparePartDocument() }
    }

    override suspend fun selectById(id: Long): DSparePartDocument? {
        return db.sparePartDocumentQueries.selectById(id).awaitAsOneOrNull()?.toDSparePartDocument()
    }

    override suspend fun selectByServerId(serverId: Long): DSparePartDocument? {
        return db.sparePartDocumentQueries.selectByServerId(serverId).awaitAsOneOrNull()?.toDSparePartDocument()
    }

    override suspend fun deleteById(id: Long) {
        db.sparePartDocumentQueries.deleteById(id)
    }
    
    override suspend fun deleteAllBySparePartId(sparePartId: Long) {
        db.sparePartDocumentQueries.deleteAllBySparePartId(sparePartId)
    }
}

fun SparePartDocument.toDSparePartDocument(): DSparePartDocument {
    return DSparePartDocument(
        id = server_id ?: 0,
        localId = id,
        sparePartId = server_spare_part_id ?: 0,
        localSparePartId = spare_part_id,
        vehicleVin = vehicle_vin,
        name = name,
        filePath = file_path,
        fileType = file_type,
        createdAt = created_at,
        updatedAt = updated_at,
        sizeMb = size_mb
    )
}
